/* eslint-disable no-use-before-define, no-unused-vars */

import React from "react";
import {
  ActivityIndicator,
  Button as RNButton,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import MenuButton from "../components/MenuButton";
import WebHeading from "../components/WebHeading";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { initValidation } from "../redux/actions/validation";
import { sendSuccess } from "../redux/actions/remediation";
import { goHome, resetStore } from "../redux/actions/menu";
import Icon from "react-native-vector-icons/FontAwesome";
import { RepositStyles } from "../utils/styles";
import Phone from "../utils/Phone";
import { goHomeWeb } from "../utils/goTo";

const errorColors = {
  green: "#51C76D",
  orange: "#F0A436",
  red: "#E02154",
};

const check = (
  <Icon
    name="check-circle"
    size={100}
    style={{ marginBottom: 30 }}
    color={errorColors.positive}
  />
);

const checkCircle = (
  <Icon name="check-circle" size={20} color={errorColors.positive} />
);
const timeCircle = (
  <Icon name="exclamation-circle" size={20} color={errorColors.negative} />
);
const questionCircle = (
  <Icon name="warning" size={20} color={errorColors.unknown} />
);

const mapStateToProps = (state) => ({
  box: state.box,
  validation: state.validation,
  menu: state.menu,
});

const mapDispatchToProps = (dispatch) => {
  return {
    validationActions: bindActionCreators(
      { initValidation, sendSuccess, resetStore },
      dispatch
    ),
    menuActions: bindActionCreators({ goHome }, dispatch),
  };
};
const ValidationComponent = ({ name, message, state, value, unit }) => {
  return (
    <View
      style={{ flexDirection: "row", marginVertical: 20, marginHorizontal: 20 }}
    >
      <Text style={{ marginTop: 2 }}>
        {state === "good"
          ? checkCircle
          : state === "orange"
          ? questionCircle
          : timeCircle}
      </Text>
      <View>
        <Text
          style={{
            ...RepositStyles.welcomeText,
            marginLeft: 10,
            color:
              state === "good"
                ? errorColors.positive
                : state === "orange"
                ? errorColors.unknown
                : errorColors.negative,
          }}
        >
          {name}
        </Text>
        {value === null || value === undefined ? null : (
          <Text style={{ marginHorizontal: 10, marginVertical: 2 }}>
            2 minute average:{" "}
            <Text style={{ fontWeight: "bold" }}>
              {" "}
              {value.toPrecision(3) + unit}{" "}
            </Text>
          </Text>
        )}
        {state === "good" ? null : (
          <View>
            <Text
              style={{
                marginHorizontal: 10,
                marginVertical: 2,
                fontWeight: "bold",
              }}
            >
              {message}
            </Text>
            <Text style={{ marginHorizontal: 10, marginVertical: 2 }}>
              {name.toLowerCase().includes("battery") ||
              name.toLowerCase().includes("inverter")
                ? "Check that the cat5e cable is plugged into the Reposit Box's ethernet port"
                : "Check that the RS485 plug is inserted into the Reposit Box"}
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

const ErrorSummary = ({ components }) => {
  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          flex: 1,
          justifyContent: "flex-end",
          borderBottomWidth: 1,
          borderBottomColor: "#D2D2D2",
        }}
      >
        <Text
          style={{
            ...RepositStyles.welcomeText,
            textAlign: "center",
            fontSize: 16,
            marginBottom: 5,
          }}
        >
          {components.length} Problem{components.length === 1 ? null : "s"}{" "}
          found during setup
        </Text>
      </View>
      <View style={{ flex: 8 }}>
        <ScrollView>
          {components.map((component) => (
            <ValidationComponent
              key={component.name}
              name={component.name}
              message={component.short}
              state={component.state}
              value={component.value}
              unit={component.unit}
            />
          ))}
        </ScrollView>
      </View>
    </View>
  );
};

const FullReport = ({ components }) => {
  return (
    <View style={{ flex: 1 }}>
      <ScrollView>
        {components.map((component) => (
          <ValidationComponent
            key={component.name}
            name={component.name}
            message={component.short}
            state={component.state}
            value={component.value}
            unit={component.unit}
          />
        ))}
      </ScrollView>
    </View>
  );
};

class ReplaceValidation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullReport: false,
    };
  }
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "Replacement Box",
  };

  finishAndGoHome = () => {
    this.props.validationActions.sendSuccess(this.props.box.serialNumber);
    if (Platform.OS === "web") {
      this.props.validationActions.resetStore();
      goHomeWeb();
    }
    this.props.menuActions.goHome();
  };

  componentDidMount() {
    this.props.validationActions.initValidation(this.props.box.serialNumber);
  }

  reValidate = () => {
    this.props.validationActions.initValidation(this.props.box.serialNumber);
  };

  render() {
    const noDataComponents = this.props.validation.allComponents.filter(
      (component) =>
        component.value === null &&
        !component.name.toLowerCase().includes("house")
    );
    let navigate;
    if (Platform.OS !== "web") {
      navigate = this.props.navigation.navigate;
    } else {
      navigate = null;
    }
    return (
      <View style={styles.wrapper}>
        <WebHeading title="New Setup" />
        <View style={{ flex: 1, alignItems: "center" }}>
          <View style={{ flex: 1, maxWidth: 800 }}>
            <View style={{ flex: 1, justifyContent: "center" }}>
              <Text style={RepositStyles.headerText}>Report</Text>
            </View>
            <View style={{ flex: 8 }}>
              {this.props.validation.fetching ? (
                <View style={{ flex: 1 }}>
                  <View style={{ flex: 1 }} />
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ActivityIndicator size="large" />
                    <Text
                      style={{
                        ...RepositStyles.headerText,
                        marginVertical: 30,
                      }}
                    >
                      Validating Installation
                    </Text>
                  </View>
                  <View style={{ flex: 3 }} />
                </View>
              ) : noDataComponents.length > 0 ? (
                <View style={{ flex: 1 }}>
                  <View style={{ flex: 4 }}>
                    <ErrorSummary components={noDataComponents} />
                  </View>
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "center",
                      marginBottom: 10,
                    }}
                  >
                    <RNButton
                      title="Revalidate"
                      onPress={() => this.reValidate()}
                      color="#4698CB"
                    />
                  </View>
                  <View
                    style={{
                      flex: 1,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Phone>Call Reposit on</Phone>
                  </View>
                </View>
              ) : (
                <View style={{ flex: 1, alignItems: "center" }}>
                  <View
                    style={{
                      flex: 1,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          ...RepositStyles.welcomeText,
                          textAlign: "center",
                          fontSize: 16,
                          marginHorizontal: 30,
                        }}
                      >
                        The Reposit Box has been successfully replaced.
                      </Text>
                    </View>
                    <View style={{ flex: 1 }}>{check}</View>
                  </View>

                  <View style={{ flex: 1, justifyContent: "center" }}>
                    <RNButton
                      title="Done"
                      onPress={() => this.finishAndGoHome()}
                      color="#4698CB"
                    />
                  </View>
                </View>
              )}
            </View>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: { backgroundColor: "white", flex: 1 },
  heading: {
    marginHorizontal: 20,
  },
  headingText: { fontSize: 24, textAlign: "center", fontWeight: "300" },
  text: {
    fontSize: 20,
    lineHeight: 25,
    fontWeight: "300",
    marginHorizontal: 10,
  },
  bodyText: {
    marginVertical: 10,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReplaceValidation);



// WEBPACK FOOTER //
// ./src/containers/ReplaceValidation.js